import { Pipe, PipeTransform } from '@angular/core';
import { UserRole, UserRoleNames } from '../../users/models/user.model';

@Pipe({
  name: 'userRole',
})
export class UserRolePipe implements PipeTransform {
  transform(value: any, ...args: any[]) {
    if (!value) return '';

    return UserRoleNames[value as UserRole];
  }
}
